import { Lotus } from './Brand';

export const SectionHeading = ({ eyebrow, title, description, children, id }) => (
  <div className="section-heading" data-testid={`${id}-heading`}>
    <div className="section-heading-title"><Lotus size={43} /><div><p className="eyebrow">{eyebrow}</p><h2>{title}</h2></div></div>
    {description && <p className="section-description">{description}</p>}
    {children && <div className="section-heading-action">{children}</div>}
  </div>
);